module.exports = __webpack_public_path__ + "static/media/notificacion_categoria_eventos.4399945a.png";